/**
 * This file includes all lazy components for optimizing the build performance
 */
import { lazy } from 'react';

export const OrganizationsElement = lazy(() =>
  import('../pages/organizations').then((module) => ({
    default: module.Organizations
  }))
);

/**
 * The Zoom video call, loaded only when someone actually opens a call.
 *
 * ZoomIndex pulls in the Zoom Video SDK, jsrsasign (for signing the session
 * JWT) and the whole of antd's stylesheet. Statically imported, every user
 * downloaded and parsed all of that on first load, including the many who
 * never make a call. Splitting it here keeps it out of the initial bundle.
 */
export const ZoomIndexElement = lazy(() => import('../pages/new-designs/tabs/zoom/ZoomIndex'));

export const LoginElement = lazy(() =>
  import('../pages/login/Login').then((module) => ({
    default: module.default
  }))
);

// Platform-admin-only dashboard: /#/app/course-creation-time
export const CourseCreationTimeElement = lazy(() =>
  import('../pages/new-designs/tabs/course-creation-time/CourseCreationTimePage').then((module) => ({
    default: module.default
  }))
);

// Platform-admin-only dashboard: /#/app/elliott-conversations
export const ElliottConversationsElement = lazy(() =>
  import('../pages/new-designs/tabs/elliott-conversations/ElliottConversationsPage').then(
    (module) => ({
      default: module.default
    })
  )
);
